import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useParams} from 'react-router-dom';
import axios from "axios";

import LinearProgress from '@material-ui/core/LinearProgress';
import CampaignDetails from './components/CampaignDetails';

import {getCampaign, clearCurrentCampaign} from '../../redux/actions/campaigns';
import {notistackError} from '../../redux/actions/notistack';

import {API_ROOT_URL} from '../../configs';


const ViewCampaign = () => {
	const dispatch = useDispatch();
	const {campaign_id} = useParams();
	const {current_campaign} = useSelector(state => state.campaigns);
	const {user} = useSelector(state => state.auth);
	const [groupDetails, setGroupDetails] = useState([]);
	const campaign = current_campaign;

	// Keyed on campaign_id: the route is /:campaign_id, so navigating between
	// campaigns can change the param without remounting this component.
	useEffect(() => {
		dispatch(getCampaign(campaign_id));
		// Clear on cleanup: current_campaign is global redux state, so without
		// this the previously viewed campaign renders here (the 0 === 0 gate
		// below passes for a stale zero-group campaign) until the fetch for
		// this campaign_id resolves.
		return () => dispatch(clearCurrentCampaign());
	}, [campaign_id]);

	useEffect(() => {
		if(!(Object.keys(current_campaign).length === 0)) {
			getAllGroupDetails();
		}
	},[current_campaign]);

	const getGroupDetails = (groupId) => {
		const headers = {
			'Content-Type': 'application/json',
			'authorization': user.token
		};
		const url = `${API_ROOT_URL}/group/${groupId}`;

		return axios.get(url, {headers});
	}

	const getAllGroupDetails = () => {
		Promise.all(
			current_campaign.groups.map(groupId => {
				return getGroupDetails(groupId)
			})
		).then(responses => {
			setGroupDetails(responses.map(({data}) => data));
		}).catch(() => {
			// Without this, a single failed group fetch leaves the progress
			// bar spinning forever with no feedback.
			dispatch(notistackError('Failed to load group details. Please try again.'));
		});
	}


	const render = () => {
		const campaign_loaded = !(Object.keys(current_campaign).length === 0);
		// Render once group details for every group have resolved. A campaign
		// with no groups resolves immediately (0 === 0) instead of spinning forever.
		const group_details_ready = campaign_loaded && groupDetails.length === current_campaign.groups.length;

		if(campaign_loaded && group_details_ready) {
			const campaign = {...current_campaign, template: current_campaign.template_message, groups: groupDetails};

			return <CampaignDetails campaign={campaign}/>
		}
		else {
			return <LinearProgress />
		}
	}

	return (
		<React.Fragment>
			{render()}
		</React.Fragment>
	)
}

export default ViewCampaign;